import { openBlock, createElementBlock, createElementVNode, createStaticVNode, getCurrentInstance, defineComponent, useSlots, ref, computed, watch, provide, onBeforeMount, onMounted, onBeforeUnmount, normalizeClass, unref, createCommentVNode, renderSlot, createBlock, resolveDynamicComponent, createTextVNode, toDisplayString, withModifiers, withDirectives, createVNode, vShow, Fragment, renderList, withCtx, nextTick } from 'vue';
import UiError from '@omnica/error-vue3';
import { UiPopper } from '@omnica/popper-vue3';
import { ALIGN } from '@omnica/error';
import { APPEARANCE, SIZE } from '@omnica/input';
import { PLACEMENT } from '@omnica/popper';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

const _hoisted_1$2 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$2 = /*#__PURE__*/createElementVNode("path", {
  d: "M4 12a8 8 0 1116 0 8 8 0 01-16 0zm11 2.045c0-.122-.05-.24-.14-.324L13.148 12l1.712-1.721a.445.445 0 000-.648l-.49-.49a.444.444 0 00-.649 0L12 10.851 10.279 9.14a.444.444 0 00-.648 0l-.49.49a.444.444 0 000 .649L10.851 12 9.14 13.721a.444.444 0 000 .648l.49.49a.444.444 0 00.649 0L12 13.149l1.721 1.712a.444.444 0 00.648 0l.49-.49a.445.445 0 00.141-.325z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$2 = [
  _hoisted_2$2
];

function render$1(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$2, _hoisted_3$2))
}

const _hoisted_1$1 = {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.0",
  fill: "currentColor",
  viewBox: "0 0 128 128",
  style: {"padding":"2px"}
};
const _hoisted_2$1 = /*#__PURE__*/createStaticVNode("<g transform=\"matrix(-1 0 0 1 128 0)\"><circle cx=\"16\" cy=\"64\" r=\"13\"></circle><circle cx=\"16\" cy=\"64\" r=\"11.344\" transform=\"rotate(45 64 64)\"></circle><circle cx=\"16\" cy=\"64\" r=\"9.531\" transform=\"rotate(90 64 64)\"></circle><circle cx=\"16\" cy=\"64\" r=\"7.75\" transform=\"rotate(135 64 64)\"></circle><circle cx=\"16\" cy=\"64\" r=\"7.063\" transform=\"rotate(180 64 64)\"></circle><circle cx=\"16\" cy=\"64\" r=\"5.063\" transform=\"rotate(225 64 64)\"></circle><circle cx=\"16\" cy=\"64\" r=\"4.438\" transform=\"rotate(270 64 64)\"></circle><circle cx=\"16\" cy=\"64\" r=\"3.375\" transform=\"rotate(315 64 64)\"></circle><animateTransform attributeName=\"transform\" type=\"rotate\" values=\"0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64;\" calcMode=\"discrete\" dur=\"960ms\" repeatCount=\"indefinite\"></animateTransform></g>", 1);
const _hoisted_3$1 = [
  _hoisted_2$1
];

function render(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1, _hoisted_3$1))
}

const componentExists = (name) => {
    var _a, _b, _c;
    return name in ((_c = (_b = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.appContext) === null || _b === void 0 ? void 0 : _b.components) !== null && _c !== void 0 ? _c : {});
};

const _hoisted_1 = {
    key: 1,
    class: "omnica-input__prefix"
};
const _hoisted_2 = ["id", "type", "name", "value", "autocomplete", "placeholder", "max", "min", "step", "maxlength", "inputmode", "pattern", "readonly", "required", "disabled"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { key: 3 };
const _hoisted_5 = {
    key: 4,
    class: "omnica-input__icon"
};
const _hoisted_6 = {
    key: 0,
    class: "omnica-input__error-list"
};
const ALLOWED_NUMBER_CODES = [8, 46, 13, 37, 39];
const DECIMAL_SEPARATORS = [',', '.'];
const USER_AGENT = navigator.userAgent;
const IS_ANDROID = USER_AGENT.toLowerCase().includes('android');
const IS_APPLE = /Apple Computer/.test(navigator.vendor);
const IS_DESKTOP_SAFARI = /Safari/i.test(USER_AGENT) && !/Mobi|Android/i.test(USER_AGENT) && IS_APPLE;
const IS_FIREFOX = USER_AGENT.search(/Firefox/) > 0;
const isInteger = (value) => !isNaN(parseInt(String(value)));
const isNumeric = (value) => !isNaN(parseFloat(String(value)));
const isSeparator = (char) => DECIMAL_SEPARATORS.some(d => d === char);
let counter = 0;
const __default__ = {};
var script = /*#__PURE__*/ defineComponent(Object.assign(Object.assign({}, __default__), { __name: 'UiInput', props: {
        /** Атрибут id нативного поля ввода input. Должен быть уникальным на странице */
        id: {
            type: String,
            default: () => `ui-input-${++counter}`,
        },
        /** Атрибут name нативного поля ввода input */
        name: {
            type: String,
            default: null,
        },
        /** Атрибут type нативного поля ввода input */
        type: {
            type: String,
            default: 'text',
        },
        /** Значение инпута при инициализации */
        value: {
            type: [String, Number],
            default: '',
        },
        /** Атрибут autocomplete нативного поля ввода input */
        autocomplete: {
            type: String,
            validator: (value) => ['on', 'off'].includes(value),
            default: 'off',
        },
        /** Атрибут placeholder нативного поля ввода input */
        placeholder: {
            type: String,
            default: '',
        },
        /** Атрибут max-length нативного поля ввода input */
        maxlength: {
            type: [String, Number],
            default: null,
        },
        /** Атрибут max нативного поля ввода type="number" */
        max: {
            type: [String, Number],
            default: Infinity,
        },
        /** Атрибут min нативного поля ввода type="number" */
        min: {
            type: [String, Number],
            default: -Infinity,
        },
        /** Атрибут step нативного поля ввода type="number" */
        step: {
            type: [String, Number],
            default: null,
        },
        /** Ввод только целых значений */
        integer: {
            type: Boolean,
            default: false,
        },
        /**
         * Разделитель дробной части (. или ,)
         * Имеет смысл только для input[type=number]
         */
        decimalSeparator: {
            type: String,
            validator: (separator) => DECIMAL_SEPARATORS.some(s => s === separator),
            default: null,
        },
        /** Максимальное количество знаков после запятой; имеет смысл только для input[type=number] */
        maxDecimalPlaces: {
            type: Number,
            default: null,
        },
        /** Атрибут required нативного поля ввода input */
        required: {
            type: Boolean,
            default: false,
        },
        /** Атрибут readonly нативного поля ввода input */
        readonly: {
            type: Boolean,
            default: false,
        },
        /** Заблокированный */
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Текст ошибки, выводимый при выходе значения
         * за пределы допустимого диапазона для input[type='number']
         */
        outOfRangeErrorText: {
            type: [String, Function],
            default: null,
        },
        /** Массив ошибок */
        errors: {
            type: Array,
            default: () => [],
        },
        /** Определяет, по какому краю будет выровнен текст ошибки */
        errorsTextAlign: {
            type: String,
            validator: (align) => Object.values(ALIGN).includes(align),
            default: ALIGN.LEFT,
        },
        /** Определяет, будет ли текст ошибок обрезаться через многоточие или переноситься на следующую строку */
        errorsTextEllipsis: {
            type: Boolean,
            default: false,
        },
        /** Показывать ошибки во всплывающей подсказке, если поле не outline или недостаточно длинное */
        errorsInTooltip: {
            type: Boolean,
            default: false,
        },
        /** Класс всплывающей подсказки с ошибкой */
        errorsTooltipClass: {
            type: String,
            default: '',
        },
        /** Контейнер всплывающей подсказки с ошибкой */
        errorsTooltipContainer: {
            type: null,
            validator: (value) => value === null || value instanceof Element || typeof value === 'string',
            default: null,
        },
        /** Позиционирование всплывающей подсказки с ошибкой */
        errorsTooltipPlacement: {
            type: String,
            default: PLACEMENT.RIGHT,
        },
        /** Отключить эмуляцию управления значением числового поля ввода с помощью стрелок на клавиатуре */
        disableArrows: {
            type: Boolean,
            default: false,
        },
        /** Внешний вид: обычный или inline */
        appearance: {
            type: String,
            validator: (appearance) => Object.values(APPEARANCE).includes(appearance),
            default: APPEARANCE.OUTLINED,
        },
        /** Иконка перед полем ввода input */
        leadingIcon: {
            type: String,
            default: '',
        },
        /** Будет изменяться заливка левой иконки, в зависимости от состояния поля */
        leadingIconFill: {
            type: Boolean,
            default: true,
        },
        /** Иконка после поля ввода input */
        trailingIcon: {
            type: String,
            default: '',
        },
        /** Будет изменяться заливка правой иконки, в зависимости от состояния поля */
        trailingIconFill: {
            type: Boolean,
            default: true,
        },
        /** Сфокусироанный внешний вид */
        active: {
            type: Boolean,
            default: false,
        },
        /** Иконка или текст ввида "https:" перед полем ввода */
        prefix: {
            type: String,
            default: null,
        },
        /** Отображается процесс загрузки в виде спиннера */
        loading: {
            type: Boolean,
            default: false,
        },
        /** Отображает иконку сброса ввиде крестика */
        clearable: {
            type: Boolean,
            default: false,
        },
        /** Включает автоматическое изменение ширины по мере ввода текста */
        fitContent: {
            type: Boolean,
            default: false,
        },
        /**
         * Минимальное значение поля ввода (без учета иконок и т.п)
         * Для fitContent минимальная ширина устанавливается
         * по ширине placeholder'а. Это свойство позволяет это переопределить
         */
        minWidth: {
            type: Number,
            default: null,
        },
        /** Будет установлен фокус при монтировании элемента */
        withFocus: {
            type: Boolean,
            default: false,
        },
        /** Выделить содержимое поля ввода при получении фокуса */
        selectOnFocus: {
            type: Boolean,
            default: false,
        },
        /** Подсказывает браузерам для устройств с экранной клавиатурой, какой вариант демонстрировать */
        inputmode: {
            type: String,
            default: null,
        },
        /** Атрибут pattern нативного поля ввода input */
        pattern: {
            type: String,
            default: null,
        },
        /** Жирное начертание */
        accent: {
            type: Boolean,
            default: false,
        },
        /** Размер поля ввода. Сейчас применяется только для appearance === 'inline' */
        size: {
            type: String,
            validator: (size) => Object.values(SIZE).includes(size),
            default: SIZE.SM,
        },
        /**
         * Инвертированные цвета. Сейчас применяется
         * только для appearance === 'inline'
         */
        inversion: {
            type: Boolean,
            default: false,
        },
        /**
         * Снятие фокуса с поля ввода при нажатии Enter и Esc
         * При снятии фокуса происходит выпуск события input-save, если снятие вызвано не нажатием ESC
         * (Логика в ДС описана для InlineEdit)
         */
        saveOnBlur: {
            type: Boolean,
            default: false,
        },
    }, emits: [
        /** Срабатывает при потере фокуса полем ввода */
        'blur',
        /** Срабатывает после потери фокуса и изменения значения поля ввода */
        'change',
        /** Событие срабатывает при сбросе значения инпута */
        'clear',
        /** Срабатывает при установке фокуса на поле ввода */
        'focus',
        /** Срабатывает при вводе значения в поле ввода */
        'input',
        /** Событие срабатывает после изменения ширины поля ввода */
        'input-resize',
        /** Событие срабатывает после изменения ширины поля ввода */
        'input-save',
        /** Срабатывает, когда клавиша была нажата */
        'keydown',
        /** Срабатывает, когда пользователь инициирует действие вставки через пользовательский интерфейс браузера */
        'paste',
        /** Срабатывает при вводе значения в поле ввода */
        'update:value',
    ], setup(__props, { expose, emit }) {
        const props = __props;
        const slots = useSlots();
        const width = ref(0);
        const usedDecimalSeparator = ref(props.decimalSeparator);
        const hasLeadingIcon = ref(false);
        const hasTrailingIcon = ref(false);
        const focused = ref(false);
        const disposed = ref(false);
        const isInline = computed(() => props.appearance === APPEARANCE.INLINE);
        const isOutlined = computed(() => props.appearance === APPEARANCE.OUTLINED);
        const isShort = computed(() => width.value > 0 && width.value < 192);
        const hasIconComponent = componentExists('UiIcon');
        const hasNumericFormatting = computed(() => {
            // @TODO для Chrome на Android не срабатывает prevent в keydown/keydown, пока отключаем эти доп. возможности
            return !IS_ANDROID && (!!props.maxDecimalPlaces || !!props.decimalSeparator || props.integer);
        });
        const hasPrefix = computed(() => isOutlined.value && (!!props.prefix || !!slots.prefix));
        /** Определяет, является ли поле ввода числовым */
        const isNumericType = computed(() => {
            return ['decimal', 'number'].includes(props.type) || hasNumericFormatting.value;
        });
        const isOutOfRange = computed(() => {
            return !focused.value
                && isNumericType.value
                && isNumeric(props.value)
                && (props.value > props.max || props.value < props.min);
        });
        const errorList = computed(() => {
            const errors = [];
            if (isOutOfRange.value && props.outOfRangeErrorText) {
                errors.push(props.outOfRangeErrorText);
            }
            errors.push(...props.errors);
            return errors;
        });
        const invalid = computed(() => isOutOfRange.value || errorList.value.length > 0);
        const decimalPlaces = (value) => {
            const [, fraction] = String(value).replace(',', '.').split('.');
            return fraction ? fraction.length : 0;
        };
        const isMaximumOfDecimalPlacesExceeded = (value) => {
            return props.maxDecimalPlaces !== undefined
                && props.maxDecimalPlaces > 0
                && decimalPlaces(value) > props.maxDecimalPlaces;
        };
        const valueComputed = computed(() => {
            var _a, _b;
            if (props.value === null) {
                return props.value;
            }
            let value = String(props.value);
            if (isMaximumOfDecimalPlacesExceeded(value)) {
                const numericPattern = new RegExp('[0-9]*.[0-9]{' + props.maxDecimalPlaces + '}');
                const numericMatches = (_a = value.match(numericPattern)) !== null && _a !== void 0 ? _a : [];
                value = (_b = numericMatches[0]) !== null && _b !== void 0 ? _b : '';
            }
            if (hasNumericFormatting.value && usedDecimalSeparator.value === ',') {
                value = value.toString().replace('.', ',');
            }
            return value;
        });
        const root = ref(null);
        const inner = ref(null);
        const input = ref(null);
        const refPlaceholder = ref(null);
        const forceRedraw = (el) => {
            // eslint-disable-next-line no-unused-expressions
            el.clientWidth;
        };
        const getInputScrollWidth = () => {
            const el = input.value;
            if (!el) {
                return 0;
            }
            let width = el.scrollWidth;
            if (IS_DESKTOP_SAFARI) { // Safari не учитывает padding элемента
                const style = getComputedStyle(el);
                const pl = parseFloat(style.paddingLeft) || 0;
                const pr = parseFloat(style.paddingRight) || 0;
                width += pl + pr;
            }
            return width + 1;
        };
        const getInputContentWidth = () => __awaiter(this, void 0, void 0, function* () {
            const el = input.value;
            if (!el) {
                return 0;
            }
            const width = el.style.width;
            const transition = el.style.transition;
            el.style.transition = 'none';
            el.style.width = '0px';
            yield nextTick();
            const scrollWidth = getInputScrollWidth();
            el.style.width = width;
            forceRedraw(el);
            el.style.transition = transition;
            return scrollWidth;
        });
        const updateFlags = () => {
            const el = root.value;
            if (el) {
                hasLeadingIcon.value = !!el.querySelector('.omnica-input__icon_leading');
                hasTrailingIcon.value = !!el.querySelector('.omnica-input__icon_trailing');
            }
        };
        const updateWidth = () => {
            var _a, _b;
            width.value = (_b = (_a = inner.value) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
        };
        /** Устанавливает ширину поля ввода в зависимости от содержимого */
        const adjustWidth = () => {
            if (!props.fitContent) {
                emit('input-resize');
                return;
            }
            const placeholder = refPlaceholder.value;
            const minWidth = isInteger(props.minWidth)
                ? props.minWidth
                : placeholder
                    ? placeholder.clientWidth + 1
                    : 0;
            const el = input.value;
            el.style.transition = 'none';
            el.style.width = '0px';
            el.style.minWidth = '0px';
            nextTick(() => {
                const el = input.value;
                if (el) {
                    const scrollWidth = getInputScrollWidth();
                    if (minWidth) {
                        el.style.minWidth = props.minWidth + 'px';
                    }
                    el.style.width = scrollWidth + 'px';
                    // eslint-disable-next-line no-unused-expressions
                    el.clientWidth; // force redraw
                    el.style.transition = '';
                    emit('input-resize');
                }
            });
        };
        watch(() => props.value, (curr, prev) => __awaiter(this, void 0, void 0, function* () {
            const el = input.value;
            /**
             * При v-model.number Vue приводит значение в модели к числу.
             * Из-за этого стирается разделитель при удалении десятых (когда стираем backspace).
             */
            if (el && hasNumericFormatting.value && !/\d*\./.test(String(curr)) && /\d*\.\d$/.test(String(prev))) {
                const value = el.value;
                yield nextTick();
                el.value = value;
            }
            adjustWidth();
        }));
        watch(() => props.fitContent, (fitContent) => __awaiter(this, void 0, void 0, function* () {
            yield nextTick();
            if (fitContent) {
                adjustWidth();
                return;
            }
            const el = input.value;
            if (el) {
                el.style.width = '';
                forceRedraw(el);
            }
            emit('input-resize');
        }));
        watch(() => props.decimalSeparator, () => {
            usedDecimalSeparator.value = props.decimalSeparator;
        });
        watch(() => props.maxDecimalPlaces, adjustWidth);
        const isOverflown = () => {
            const el = input.value;
            return !!el && el.scrollWidth > el.clientWidth;
        };
        const focus = () => { var _a; return (_a = input.value) === null || _a === void 0 ? void 0 : _a.focus(); };
        const blur = () => { var _a; return (_a = input.value) === null || _a === void 0 ? void 0 : _a.blur(); };
        const clear = (event = undefined) => {
            if (!props.disabled) {
                emit('input', '');
                emit('update:value', '');
                emit('clear', event);
            }
        };
        const getInputWidth = () => __awaiter(this, void 0, void 0, function* () {
            const el = inner.value;
            if (!el) {
                return 0;
            }
            const contentWidth = yield getInputContentWidth();
            const style = getComputedStyle(el);
            const pl = parseFloat(style.paddingLeft) || 0;
            const pr = parseFloat(style.paddingRight) || 0;
            const bl = parseFloat(style.borderLeft) || 0;
            const br = parseFloat(style.borderRight) || 0;
            return contentWidth + pl + pr + bl + br;
        });
        const getSelectionStart = () => { var _a, _b; return (_b = (_a = input.value) === null || _a === void 0 ? void 0 : _a.selectionStart) !== null && _b !== void 0 ? _b : null; };
        const setSelectionRange = (start, end) => {
            var _a;
            (_a = input.value) === null || _a === void 0 ? void 0 : _a.setSelectionRange(start, end);
        };
        expose({
            isOverflown,
            focus,
            blur,
            clear,
            getInputWidth,
            getSelectionStart,
            setSelectionRange,
        });
        /** Меняет значение поля ввода с hasNumericFormatting при нажатии на стрелки. */
        const changeValueByArrow = (keyCode) => {
            if (props.disableArrows || (keyCode !== 38 && keyCode !== 40)) {
                return;
            }
            const max = Number(props.max);
            const min = Number(props.min);
            const isArrowTop = keyCode === 38;
            const step = Number(props.step || 1);
            const oldValue = Number(+props.value || 0);
            const newValue = isArrowTop
                ? (oldValue + step)
                : (oldValue - step);
            if ((isArrowTop && newValue <= max) || (!isArrowTop && newValue >= min)) {
                const value = newValue.toFixed(Math.max(decimalPlaces(step), decimalPlaces(oldValue)));
                emit('input', value);
                emit('update:value', value);
                adjustWidth();
            }
        };
        const onInput = (event) => {
            const char = event.data;
            const input = event.target;
            let value = input.value;
            if (hasNumericFormatting.value) {
                value = value.replace(',', '.');
                if (isMaximumOfDecimalPlacesExceeded(value)) {
                    input.value = valueComputed.value;
                    adjustWidth();
                    return;
                }
                if (Number(value) === Number(props.value)
                    && isSeparator(char)
                    && usedDecimalSeparator.value !== char) {
                    input.value = value.replace(char, usedDecimalSeparator.value);
                    adjustWidth();
                    return;
                }
            }
            emit('input', value);
            emit('update:value', value);
            adjustWidth();
        };
        let byEsc = false;
        let snapshot = '';
        const onChange = (event) => {
            const value = event.target.value;
            if (snapshot !== value && !byEsc && props.saveOnBlur) {
                snapshot = value;
            }
            emit('change', value);
        };
        const onKeyDown = (event) => {
            const input = event.target;
            const [usedSeparator] = DECIMAL_SEPARATORS.filter(el => input.value.includes(el));
            const code = event.keyCode;
            const isAllowedSeparator = !usedSeparator && DECIMAL_SEPARATORS.includes(event.key);
            const isExponent = code === 69; // Запрет на ввод экспоненты в числовые поля ввода
            const isManualNumberControl = IS_FIREFOX || hasNumericFormatting.value;
            if (!props.decimalSeparator) {
                usedDecimalSeparator.value = usedSeparator
                    ? usedSeparator
                    : isAllowedSeparator
                        ? event.key
                        : null;
            }
            const isAllowed = !isNaN(+event.key)
                || (isAllowedSeparator && !props.integer)
                || ALLOWED_NUMBER_CODES.includes(event.keyCode)
                || event.ctrlKey;
            if (isNumericType.value && ((isManualNumberControl && !isAllowed) || isExponent)) {
                event.preventDefault();
                changeValueByArrow(code);
                return;
            }
            emit('keydown', event);
            if (!props.saveOnBlur && !isInline.value) {
                return;
            }
            if (['Enter', 'Escape'].includes(event.key)) {
                byEsc = event.key === 'Escape';
                blur();
            }
        };
        const onFocus = (event = undefined) => __awaiter(this, void 0, void 0, function* () {
            const el = input.value;
            focused.value = true;
            if (el && !props.readonly && (props.selectOnFocus || isInline.value)) {
                el.scrollLeft = el.scrollWidth;
                yield nextTick();
                el.select();
            }
            emit('focus', event);
        });
        const onBlur = (event) => {
            const input = event.target;
            focused.value = false;
            emit('blur', event);
            if ((props.saveOnBlur || isInline.value) && !byEsc) {
                emit('input-save', input.value);
            }
            if (props.saveOnBlur && byEsc) {
                emit('input', snapshot);
                emit('update:value', snapshot);
            }
            if (byEsc) {
                byEsc = false;
            }
        };
        const insert = (text) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            if (!text) {
                return;
            }
            const start = (_b = (_a = input.value) === null || _a === void 0 ? void 0 : _a.selectionStart) !== null && _b !== void 0 ? _b : 0;
            const end = (_d = (_c = input.value) === null || _c === void 0 ? void 0 : _c.selectionEnd) !== null && _d !== void 0 ? _d : 0;
            const position = start + text.length;
            const oldValue = valueComputed.value;
            const newValue = oldValue.substring(0, start) + text + oldValue.substring(end);
            emit('input', newValue);
            emit('update:value', newValue);
            yield nextTick();
            setSelectionRange(position, position);
            focus();
        });
        provide('__OmnicaTextField_insert', insert);
        let intersectionObserver = null;
        let mutationObserver = null;
        onBeforeMount(() => {
            hasLeadingIcon.value = !!slots['leading-icon'] || !!props.leadingIcon;
            hasTrailingIcon.value = !!slots['trailing-icon'] || !!props.trailingIcon;
            if (props.saveOnBlur) {
                snapshot = props.value;
            }
        });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            updateWidth();
            adjustWidth();
            if (window.IntersectionObserver) {
                intersectionObserver = new IntersectionObserver(([entry]) => {
                    if (entry.intersectionRatio > 0) {
                        adjustWidth();
                        updateWidth();
                    }
                });
                intersectionObserver.observe(input.value);
            }
            mutationObserver = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    if (['childList', 'subtree'].includes(mutation.type)) {
                        updateFlags();
                    }
                }
            });
            mutationObserver.observe(root.value, {
                childList: true,
                subtree: true,
            });
            window.addEventListener('resize', updateWidth);
            if (props.withFocus) {
                yield nextTick();
                focus();
            }
        }));
        onBeforeUnmount(() => {
            window.removeEventListener('resize', updateWidth);
            intersectionObserver === null || intersectionObserver === void 0 ? void 0 : intersectionObserver.disconnect();
            mutationObserver === null || mutationObserver === void 0 ? void 0 : mutationObserver.disconnect();
            disposed.value = true;
        });
        return (_ctx, _cache) => {
            return (openBlock(), createElementBlock("div", {
                ref_key: "root",
                ref: root,
                class: normalizeClass({
                    'omnica-input': true,
                    [`omnica-input_${__props.appearance}`]: true,
                    [`omnica-input_${__props.size}`]: true,
                    'omnica-input_accent': __props.inversion && unref(isInline),
                    'omnica-input_clearable': __props.clearable,
                    'omnica-input_disabled': __props.disabled,
                    'omnica-input_filled': !!__props.value,
                    'omnica-input_fit': __props.fitContent,
                    'omnica-input_focused': focused.value || __props.active,
                    'omnica-input_has-leading-icon': hasLeadingIcon.value && !__props.prefix,
                    'omnica-input_has-trailing-icon': hasTrailingIcon.value,
                    'omnica-input_invalid': unref(invalid) && !focused.value,
                    'omnica-input_inverse': __props.inversion && unref(isInline),
                    'omnica-input_readonly': __props.readonly,
                })
            }, [
                createElementVNode("div", {
                    ref_key: "inner",
                    ref: inner,
                    class: "omnica-input__inner",
                    onClick: focus
                }, [
                    ((_ctx.$slots['leading-icon'] || __props.leadingIcon) && !unref(hasPrefix))
                        ? (openBlock(), createElementBlock("div", {
                            key: 0,
                            class: normalizeClass({
                                'omnica-input__icon': true,
                                'omnica-input__icon_leading': true,
                                'omnica-input__icon_fill': __props.leadingIconFill,
                            })
                        }, [
                            createCommentVNode(" @slot Иконка вначале инпута "),
                            renderSlot(_ctx.$slots, "leading-icon", {}, () => [
                                (unref(hasIconComponent))
                                    ? (openBlock(), createBlock(resolveDynamicComponent('UiIcon'), {
                                        key: 0,
                                        name: __props.leadingIcon
                                    }, null, 8 /* PROPS */, ["name"]))
                                    : createCommentVNode("v-if", true)
                            ])
                        ], 2 /* CLASS */))
                        : createCommentVNode("v-if", true),
                    (unref(hasPrefix))
                        ? (openBlock(), createElementBlock("div", _hoisted_1, [
                            createCommentVNode(" @slot Небольшой блок с текстом и/или иконкой вначале инпута. Например \\\"https://\\\" "),
                            renderSlot(_ctx.$slots, "prefix", {}, () => [
                                createTextVNode(toDisplayString(__props.prefix), 1 /* TEXT */)
                            ])
                        ]))
                        : createCommentVNode("v-if", true),
                    createElementVNode("input", {
                        id: __props.id,
                        ref_key: "input",
                        ref: input,
                        type: !unref(hasNumericFormatting) ? __props.type : 'tel',
                        name: __props.name,
                        value: unref(valueComputed),
                        autocomplete: __props.autocomplete,
                        placeholder: __props.placeholder,
                        max: unref(isNumericType) ? __props.max : null,
                        min: unref(isNumericType) ? __props.min : null,
                        step: unref(isNumericType) && __props.step ? __props.step : null,
                        maxlength: __props.maxlength,
                        inputmode: __props.inputmode,
                        pattern: __props.pattern,
                        readonly: __props.readonly,
                        required: __props.required,
                        disabled: __props.disabled,
                        class: "omnica-input__input",
                        onInput: onInput,
                        onKeydown: onKeyDown,
                        onChange: onChange,
                        onFocus: onFocus,
                        onBlur: onBlur,
                        onPaste: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('paste', $event)))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2),
                    (__props.clearable && (!!__props.value || !__props.fitContent))
                        ? (openBlock(), createElementBlock("div", {
                            key: 2,
                            class: "omnica-input__eraser",
                            onClick: withModifiers(clear, ["stop"])
                        }, [
                            withDirectives(createVNode(unref(render$1), { class: "omnica-input__eraser-icon" }, null, 512 /* NEED_PATCH */), [
                                [vShow, !!__props.value]
                            ])
                        ], 8 /* PROPS */, _hoisted_3))
                        : createCommentVNode("v-if", true),
                    (_ctx.$slots['addons'])
                        ? (openBlock(), createElementBlock("div", _hoisted_4, [
                            createCommentVNode(" @slot Компонент вставки специальных символов. Например emoji "),
                            renderSlot(_ctx.$slots, "addons")
                        ]))
                        : createCommentVNode("v-if", true),
                    (__props.loading)
                        ? (openBlock(), createElementBlock("div", _hoisted_5, [
                            createVNode(unref(render), { class: "omnica-input__spinner" })
                        ]))
                        : (_ctx.$slots['trailing-icon'] || __props.trailingIcon)
                            ? (openBlock(), createElementBlock("div", {
                                key: 5,
                                class: normalizeClass({
                                    'omnica-input__icon': true,
                                    'omnica-input__icon_trailing': true,
                                    'omnica-input__icon_fill': __props.trailingIconFill,
                                })
                            }, [
                                createCommentVNode(" @slot Иконка в конце инпута "),
                                renderSlot(_ctx.$slots, "trailing-icon", {}, () => [
                                    (unref(hasIconComponent))
                                        ? (openBlock(), createBlock(resolveDynamicComponent('UiIcon'), {
                                            key: 0,
                                            name: __props.trailingIcon
                                        }, null, 8 /* PROPS */, ["name"]))
                                        : createCommentVNode("v-if", true)
                                ])
                            ], 2 /* CLASS */))
                            : createCommentVNode("v-if", true),
                    (__props.fitContent)
                        ? (openBlock(), createElementBlock("div", {
                            key: 6,
                            ref_key: "refPlaceholder",
                            ref: refPlaceholder,
                            class: "omnica-input__placeholder"
                        }, toDisplayString(__props.placeholder), 513 /* TEXT, NEED_PATCH */))
                        : createCommentVNode("v-if", true)
                ], 512 /* NEED_PATCH */),
                (unref(errorList).length > 0 && !focused.value)
                    ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                        (!unref(isShort) && unref(isOutlined))
                            ? (openBlock(), createElementBlock("div", _hoisted_6, [
                                (openBlock(true), createElementBlock(Fragment, null, renderList(unref(errorList), (message, index) => {
                                    return (openBlock(), createBlock(unref(UiError), {
                                        key: index,
                                        message: message,
                                        align: __props.errorsTextAlign,
                                        ellipsis: __props.errorsTextEllipsis
                                    }, null, 8 /* PROPS */, ["message", "align", "ellipsis"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : (__props.errorsInTooltip && !disposed.value)
                                ? (openBlock(), createBlock(unref(UiPopper), {
                                    key: 1,
                                    target: () => _ctx.$refs.root,
                                    triggers: [],
                                    container: __props.errorsTooltipContainer,
                                    placement: __props.errorsTooltipPlacement,
                                    class: normalizeClass(['omnica-input__error-popper', __props.errorsTooltipClass]),
                                    dark: !unref(isInline) || !__props.inversion,
                                    shown: ""
                                }, {
                                    default: withCtx(() => [
                                        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(errorList), (message, index) => {
                                            return (openBlock(), createBlock(unref(UiError), {
                                                key: index,
                                                message: message,
                                                align: __props.errorsTextAlign,
                                                ellipsis: __props.errorsTextEllipsis,
                                                style: { "color": "inherit" }
                                            }, null, 8 /* PROPS */, ["message", "align", "ellipsis"]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["target", "container", "placement", "class", "dark"]))
                                : createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                    : createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    } }));

script.__file = "packages/input/src/UiInput.vue";

export { script as default };
